module.exports = __webpack_public_path__ + "img/5_72.0064202c.png";